import styled from 'styled-components'
import { Alert, Image } from '@sainsburys-tech/bolt'

const Container = styled.span`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  border-top: 1px solid ${props => props.theme.color.monochrome.light};
  & span > b {
    font-weight: ${props => props.theme.font.weight.bold};
  }
`

const Label = styled.span`
  display: flex;
  flex: 1;

  cursor: pointer;

  > svg {
    margin-right: 8px;
  }
`

const Link = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
  font-weight: ${props => props.theme.font.weight.bold};
  text-decoration: underline;
  cursor: pointer;

  &:hover,
  &:active {
    color: ${props => props.theme.color.palette['brand-1-dark']};
  }
`

const Section = styled.div`
  padding: 15px 10px;
  border-bottom: 1px solid ${props => props.theme.color.monochrome.light};

  ul {
    margin-bottom: 12px;
  }
  ul li {
    list-style: outside;
    margin-left: 2em;
  }
`
const SectionHeader = styled.h4``

const LabelImage = styled(Image)`
  vertical-align: middle;
  margin-right: 8px;
`

const LabelContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  & div > b {
    font-weight: ${props => props.theme.font.weight.bold};
  }

  @media screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex-direction: column;
  }
`

const ProductPanelWrapper = styled.div`
  div {
    border-bottom: none;
    padding-bottom: 0px;
  }

  border-bottom: 1px solid ${props => props.theme.color.monochrome.light};
`

const DrawerNectarPointsWrapper = styled.div`
  margin-bottom: 24px;
  margin-left: 100px;
  @media screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    margin-left: 16px;
    margin-top: 16px;
  }

  & span > b {
    font-weight: ${props => props.theme.font.weight.bold};
  }
`

const StyledAlert = styled(Alert)`
  border-radius: 3px;
  padding: 10px;
  width: auto;
  margin: 15px;
`

export {
  Container,
  Label,
  Link,
  Section,
  SectionHeader,
  LabelImage,
  LabelContentWrapper,
  ProductPanelWrapper,
  DrawerNectarPointsWrapper,
  StyledAlert
}
